// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"work","211":"works","594":"about"}[chunkId] + "." + {"112":"c159e990","211":"fc4b979b","594":"2e37887c"}[chunkId] + ".js";
};